import { Form, states } from "./Calculator";

export const calculateAmmortizingLoan = (
  form: Form,
  state: (typeof states)[number]
): string => {
  const { amount = 0, interest = 0, term = 0 } = form;

  const check = [amount, interest, term].filter((value) => Number(value) > 0);
  if (check.length !== 3) {
    return "";
  }

  const numberOfPayments = state === "bWeekly" ? term / 2 : term;
  const periodInterestRate = interest / 100 / (state === "bWeekly" ? 26 : 12);

  const monthlyPayment =
    amount *
    (periodInterestRate /
      (1 - Math.pow(1 + periodInterestRate, -numberOfPayments)));

  return monthlyPayment.toFixed(2);
};
